export default "__VITE_ASSET__D_6xRLbk__"